module.exports = __webpack_public_path__ + "img/route_53.46eda35e.jpg";